export default {
  profile: {
    key: 'profile',
    l10nKey: 'auth.profileLink',
    url: '/p/',
  },
  order: {
    key: 'myOrder',
    l10nKey: 'auth.order',
    url: '/ticket/',
  },
  achievements: {
    key: 'achievements',
    l10nKey: 'auth.achievements',
    url: '/loyalty/achievements/',
  },
  virtualcard: {
    key: 'virtualcard',
    l10nKey: 'auth.virtualcard',
    url: '/loyalty/virtualcard/',
    authorizedUrl: '/p/virtualcard/',
  },
  travelexpert: {
    key: 'travelexpert',
    l10nKey: 'auth.travelexpert',
    url: '/loyalty/travelexpert/',
  },
  login: {
    key: 'login',
    l10nKey: 'auth.signIn',
  },
  exit: {
    key: 'exit',
    l10nKey: 'auth.exit',
    locator: 'profile-exit',
  },
  profileLogin: {
    key: 'profileLogin',
    l10nKey: 'auth.profileLink',
    locator: 'profileLogin',
  },
  mobileLogin: {
    key: 'mobileLogin',
    l10nKey: 'auth.signIn',
    locator: 'mobileLogin',
  },
};
